import './ConfirmationModal.css';

/**
 * Reusable confirmation modal for accept/discard dialogs
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {string} props.title - Modal title
 * @param {string} props.message - Modal message/description
 * @param {Function} props.onConfirm - Called when user confirms
 * @param {Function} props.onCancel - Called when user cancels
 * @param {string} props.confirmLabel - Label for confirm button (default: "Confirm")
 * @param {string} props.cancelLabel - Label for cancel button (default: "Cancel")
 * @param {boolean} props.destructive - If true, confirm button uses destructive styling
 */
export default function ConfirmationModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="confirmation-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="confirmation-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmation-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="confirmation-header">
          <h2 id="confirmation-title">{title}</h2>
          {message && <p>{message}</p>}
        </header>

        <div className="confirmation-actions">
          <button
            type="button"
            className={destructive ? 'confirmation-destructive' : 'confirmation-primary'}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
          {cancelLabel && (
            <button type="button" className="confirmation-secondary" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

